/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as LabelerDefs from './defs.defs.js'
import * as LabelDefs from '../../../com/atproto/label/defs.defs.js'
import * as ModerationDefs from '../../../com/atproto/moderation/defs.defs.js'

const $nsid = 'app.bsky.labeler.service'

export { $nsid }

/** A declaration of the existence of labeler service. */
type Main = {
  $type: 'app.bsky.labeler.service'
  policies: LabelerDefs.LabelerPolicies
  labels?: l.$Typed<LabelDefs.SelfLabels> | l.Unknown$TypedObject
  createdAt: l.DatetimeString

  /**
   * The set of report reason 'codes' which are in-scope for this service to review and action. These usually align to policy categories. If not defined (distinct from empty array), all reason types are allowed.
   */
  reasonTypes?: ModerationDefs.ReasonType[]

  /**
   * The set of subject types (account, record, etc) this service accepts reports on.
   */
  subjectTypes?: ModerationDefs.SubjectType[]

  /**
   * Set of record types (collection NSIDs) which can be reported to this service. If not defined (distinct from empty array), default is any record type.
   */
  subjectCollections?: l.NsidString[]
}

export type { Main }

/** A declaration of the existence of labeler service. */
const main = l.record<'literal:self', Main>(
  'literal:self',
  $nsid,
  l.object({
    policies: l.ref<LabelerDefs.LabelerPolicies>(
      (() => LabelerDefs.labelerPolicies) as any,
    ),
    labels: l.optional(
      l.typedUnion(
        [l.typedRef<LabelDefs.SelfLabels>((() => LabelDefs.selfLabels) as any)],
        false,
      ),
    ),
    createdAt: l.string({ format: 'datetime' }),
    reasonTypes: l.optional(
      l.array(
        l.ref<ModerationDefs.ReasonType>(
          (() => ModerationDefs.reasonType) as any,
        ),
      ),
    ),
    subjectTypes: l.optional(
      l.array(
        l.ref<ModerationDefs.SubjectType>(
          (() => ModerationDefs.subjectType) as any,
        ),
      ),
    ),
    subjectCollections: l.optional(l.array(l.string({ format: 'nsid' }))),
  }),
)

export { main }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main),
  $build = /*#__PURE__*/ main.build.bind(main),
  $type = /*#__PURE__*/ main.$type
export const $assert = /*#__PURE__*/ main.assert.bind(main),
  $check = /*#__PURE__*/ main.check.bind(main),
  $cast = /*#__PURE__*/ main.cast.bind(main),
  $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main),
  $matches = /*#__PURE__*/ main.matches.bind(main),
  $parse = /*#__PURE__*/ main.parse.bind(main),
  $safeParse = /*#__PURE__*/ main.safeParse.bind(main),
  $validate = /*#__PURE__*/ main.validate.bind(main),
  $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)
